import { ccAgent } from './agent'

export const twilioTokenAPI = () => {
    return ccAgent.post('/user/twilioAccessToken');
};